// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import Slider from "react-slick";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Anouncements from "pages/Presentation/sections/Anouncements";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import SchoolIcon from "@mui/icons-material/School";
import Information from "pages/Presentation/sections/Information";
import Testimonials from "pages/Presentation/sections/Testimonials";
import Section from "pages/Presentation/sections/Section";
import HomeSlider from "pages/Presentation/sections/HomeSlider";
import Events from "pages/Events";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
// import logoImage from "assets/images/snlc-logo.png";
import headerImage from "assets/images/snlc_header.svg";
import congrats from "assets/images/congrats.png";
import { useQuery } from "@apollo/client";
import * as React from "react";
import { CONGRATULATIONS } from "../../graphql/query/congratulations";
// Custom CSS
import "../../assets/css/custom.css";

// const LogoContainer = styled("div")({
//   color: "darkslategray",
//   backgroundColor: "transparent",
//   padding: 8,
//   borderRadius: 4,
//   cursor: "pointer",
// });
// const MainHead = styled("div")({
//   color: "#FBE609",
//   backgroundColor: "transparent",
//   padding: 3,
//   textTransform: "uppercase",
//   fontWeight: "bold",
//   lineHeight: "3rem",
// });
// const Address = styled("div")({
//   color: "rgba(10, 10, 10, 1)",
//   backgroundColor: "transparent",
//   padding: 1,
//   fontSize: "18px",
//   textTransform: "none",
//   opacity: "0.8",
//   fontWeight: "600",
//   textAlign: "left",
//   width: "100%",
// });
// const BodyText = styled("div")({
//   color: "#0A0A0A",
//   backgroundColor: "transparent",
//   fontSize: "16px",
//   textTransform: "none",
//   opacity: "0.8",
//   fontWeight: "400",
//   textAlign: "justify",
//   lineHeight: "1.85",
// });
// const Affiliation = styled("div")({
//   color: "rgba(10, 10, 10, 0.8)",
//   backgroundColor: "transparent",
//   padding: 1,
//   fontSize: "14px",
//   textTransform: "none",
//   fontWeight: "600",
//   textAlign: "left",
//   width: "100%",
// });
const TopMenu = styled("div")({
  backgroundColor: "rgb(253 202 8 / 43%)",
  paddingTop: 10,
  paddingBottom: 10,
});
const HeadingText = styled("div")({
  color: "#0A0A0A",
  backgroundColor: "transparent",
  padding: 1,
  textTransform: "uppercase",
  opacity: "0.8",
  fontWeight: "400",
  fontFamily: "inherit",
});
const SocialIcon = styled("div")({
  color: "rgba(10, 10, 10, 1)",
  backgroundColor: "transparent",
  padding: 0.3,
  fontWeight: "400",
  fontFamily: "inherit",
  marginLeft: "5px",
  cursor: "pointer",
  fontSize: "14px",
  lineHeight: "12px",
  textAlign: "end",
});
const AdmissionCta = styled("div")({
  fontWeight: "600",
  fontSize: "14px",
  lineHeight: "12px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
});
const SingleSlider = styled("div")({
  minHeight: "85vh",
  marginRight: "10px",
});

function Presentation() {
  const [offset] = React.useState(0);
  const [congratulationsDatas, setCongratulationsDatas] = React.useState([]);
  const { loading, error, data } = useQuery(CONGRATULATIONS, {
    variables: {
      congratulationsFilter: {
        offset,
        limit: 60000,
        status: true,
        setAsHome: true,
        orderColumn: "id",
        orderDirection: "desc",
      },
    },
  });
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  React.useEffect(() => {
    if (loading === false) {
      if (error) {
        setCongratulationsDatas([]);
      } else {
        setCongratulationsDatas(data.congratulations.congratulations);
      }
    }
  }, [data, loading, error]);

  return (
    <>
      <TopMenu variant="gradient" sx={{ px: { xs: 2, lg: 5 } }}>
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid item lg={1} justifyContent="end">
            {/* <LogoContainer>
              <img
                src={logoImage}
                alt="Logo"
                width="100"
                cursor="pointer"
                className="img-fluid desktop-logo"
              />
            </LogoContainer> */}
          </Grid>
          <Grid item lg={7}>
            <img src={headerImage} alt="Logo" cursor="pointer" className="img-fluid desktop-logo" />
            {/* <MainHead
              className="main-head"
              style={{
                background: "rgba(10, 10, 10, 1)",
                webkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
              sx={{ fontSize: { xs: 20, lg: 45 } }}
            >
              sree narayana law college{" "}
            </MainHead> */}
            {/* <Address className="address-container">
              Puthenkavu Poothotta P.O Ernakulam, Kerala - 682307
            </Address> */}
            {/* <Affiliation className="desktop-menu">
              Recognized by Bar Council of India, New Delhi, Govt. of Kerala & Affiliated to Mahatma
              Gandhi University, Kottayam.
              <br /> Owned And Managed By SNDP Yogam 1103
            </Affiliation> */}
          </Grid>

          <Grid item lg={3}>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <Grid item lg={12}>
                <SocialIcon>
                  <a className="text-black" href="mailto:snlcpoothotta@gmail.com">
                    <MailOutlineIcon /> snlcpoothotta@gmail.com
                  </a>
                </SocialIcon>
              </Grid>
              <Grid item lg={12}>
                <SocialIcon>
                  <div className="admission-blink">
                    <a href="https://admission.snlcpoothotta.org/" target="_blank" rel="noreferrer">
                      <SchoolIcon /> Admission Portal
                    </a>
                  </div>
                  {/* <a href="https://admission.snlcpoothotta.org/" target="_blank" rel="snlc" className="admission-blink">
                    <SchoolIcon /> Admission Portal
                  </a> */}
                </SocialIcon>
              </Grid>
              <Grid item lg={3}>
                &nbsp;
              </Grid>
              <Grid item lg={9}>
                <AdmissionCta className="blink">
                  {" "}
                  For Admissions: &nbsp;
                  <a href="tel:04842792377">
                    <PhoneIcon /> 0484 - 2794377
                  </a>
                </AdmissionCta>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={1}>
            &nbsp;
          </Grid>
        </Grid>
      </TopMenu>
      <MKBox variant="gradient" bgColor="dark" shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light center />
      </MKBox>
      <HomeSlider />
      <Anouncements />
      <Card>
        <Counters />
        <Information />
        <Section />
        {congratulationsDatas.length > 0 ? (
          <Container sx={{ mt: 0.5, mb: 2 }}>
            <MKTypography py={3}>
              <HeadingText className="heading-bg" sx={{ fontWeight: "bold", fontSize: "30px" }}>
                congratulations
              </HeadingText>
              <img className="img-fluid congrats-img" width="300" height="" src={congrats} alt="" />
            </MKTypography>
            {congratulationsDatas.length > 3 ? (
              <Slider {...settings}>
                {congratulationsDatas.map((congratulations) => (
                  <SingleSlider key={congratulations.id}>
                    <Grid display="flex" justifyContent="center">
                      <img className="congrats-slider" src={congratulations.image} alt="Logo" />
                    </Grid>
                  </SingleSlider>
                ))}
              </Slider>
            ) : (
              <Grid container spacing={3}>
                {congratulationsDatas.map((congratulations) => (
                  <Grid item xs={3}>
                    <img className="congrats-slider" src={congratulations.image} alt="Logo" />
                  </Grid>
                ))}
              </Grid>
            )}
          </Container>
        ) : null}
        {/* <Container>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MKTypography variant="h2" py={3}>
                <HeadingText className="heading-bg" sx={{ fontWeight: "bold" }}>
                  projects
                </HeadingText>
              </MKTypography>
              <BodyText className="text-j">
                Sree Narayana Law College is a newly established Law Institute, situated at
                Poothotta, 20 Kms away from Kochi. The College is owned and managed by the SNDP
                Yogam Br:No. 1103, Poothotta. It is a matter of immense pride that this management
                is an organization having a large academic set up in the port city of Kerala, thanks
                to the visionary leadership. At present the management has the following
                institutions in the campus. The college aims at achieving the high ideals of Sree
                Narayana Guru who exhorted us to 'strive for the welfare of all without any
                discrimination on the basis of caste, creed or religion.
              </BodyText>
            </Grid>
            <Grid item xs={12} lg={6}>
              <ReactPlayer
                playing
                controls
                loop
                url="https://snlc-files.s3.ap-south-1.amazonaws.com/videos/snlc_video.mp4"
                className="snlc_player"
                width="100%"
                height="100%"
              />
            </Grid>
          </Grid>
        </Container> */}
        <Events />
        <Testimonials />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
